// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__mejG9","icon":"Button_icon__1l3gD","accent":"Button_accent__3zkkp","regular":"Button_regular__mHkWG"};